import PropTypes from "prop-types";
import { WineEventBooking } from "vino/components";

const Block = ({ attributes }) => {
	return <WineEventBooking attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
